import { GetMetricStatisticInput } from '@smash-sdk/transfer/07-2020';
import { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import ChartContainer from '../../components/ChartContainer/ChartContainer';
import DashboardPage from '../../components/DashboardPage/DashboardPage';
import SelectInput from '../../components/SelectInput/SelectInput';
import { loadUsages, usageState, UsageState } from '../../features/usage/usageSlice';
import { useAppDispatch, useAppSelector } from '../../hooks/redux/hooks';
import { buildDates, TimePeriod } from '../../shared/helpers/helpers';

type UnitOption = { label: string, value: GetMetricStatisticInput['unit'] };
type PeriodOption = { label: string, value: TimePeriod, units: Array<UnitOption> };

const periodOptions: Array<PeriodOption> = [
    { label: 'Last 7 days', value: '7_DAYS', units: [{ label: 'Daily', value: 'day' }] },
    { label: 'Last 4 weeks', value: '4_WEEKS', units: [{ label: 'Daily', value: 'day' }, { label: 'Weekly', value: 'week' }] },
    { label: 'Last 3 months', value: '3_MONTHS', units: [{ label: 'Daily', value: 'day' }, { label: 'Weekly', value: 'week' }, { label: 'Monthly', value: 'month' }] },
    { label: 'Last 12 months', value: '12_MONTHS', units: [{ label: 'Monthly', value: 'month' }, { label: 'Weekly', value: 'week' }] },
    { label: 'Year to date', value: 'YEAR_TO_DATE', units: [{ label: 'Daily', value: 'day' }, { label: 'Weekly', value: 'week' }, { label: 'Monthly', value: 'month' }] },
    { label: 'The last year', value: 'LAST_YEAR', units: [{ label: 'Monthly', value: 'month' }, { label: 'Weekly', value: 'week' }] },
];

const Usage = () => {
    const dispatch = useAppDispatch();
    const { transfers, files, bytesUploaded, bytesDownloaded } = useAppSelector<UsageState>(usageState);
    const [period, setPeriod] = useState<PeriodOption>(periodOptions[0]);
    const [unit, setUnit] = useState<UnitOption>(periodOptions[0].units[0]);
    const dates = buildDates(period.value);
    const [startDate, setStartDate] = useState<string>(dates.startDate);
    const [endDate, setEndDate] = useState<string>(dates.endDate);

    useEffect(() => {
        if (startDate && endDate && unit) {
            dispatch(loadUsages({ startDate, endDate, unit: unit.value }));
        }
    }, [startDate, endDate, unit]);

    function handlePeriodChange(selectedPeriod: PeriodOption) {
        setPeriod(selectedPeriod);
        setUnit(selectedPeriod.units[0]);
        const { startDate: newStartDate, endDate: newEndDate } = buildDates(selectedPeriod.value);
        setStartDate(newStartDate);
        setEndDate(newEndDate);
    }

    function handleUnitChange(selectedUnit: UnitOption) {
        setUnit(selectedUnit);
    }

    return (
        <>
            <DashboardPage heading='Reports'>
                <Row>
                    <Col>
                        <Card >
                            <Card.Header>
                                <Card.Title>Metrics</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <Row>
                                    <Col className="d-flex justify-content-start"><SelectInput options={periodOptions} defaultValue={period.value} isSearchable={false} onChange={handlePeriodChange}></SelectInput></Col>
                                    <Col className="d-flex justify-content-end"><SelectInput key={period.label} options={period.units} defaultValue={unit.value} isSearchable={false} onChange={handleUnitChange}></SelectInput></Col>
                                </Row>
                                <Row className="justify-content-md-center mt-2">
                                    <Col className="d-flex align-items-center justify-content-center p-3"><ChartContainer xValues={bytesUploaded?.data?.xValues} yValues={bytesUploaded?.data?.yValues} title='Data Uploaded' displayUnit={true} unit='GB'></ChartContainer></Col>
                                    <Col className="d-flex align-items-center justify-content-center p-3"><ChartContainer xValues={bytesDownloaded?.data?.xValues} yValues={bytesDownloaded?.data?.yValues} title='Data Downloaded' displayUnit={true} unit='GB'></ChartContainer></Col>
                                </Row>
                                <Row className="justify-content-md-center mt-2">
                                    <Col className="d-flex align-items-center justify-content-center p-3"><ChartContainer xValues={transfers?.data?.xValues} yValues={transfers?.data?.yValues} title='Transfers Created' unit='transfers'></ChartContainer></Col>
                                    <Col className="d-flex align-items-center justify-content-center p-3"><ChartContainer xValues={files?.data?.xValues} yValues={files?.data?.yValues} title='Files Uploaded' unit='files'></ChartContainer></Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>

                </Row>
            </DashboardPage>
        </>
    )
}

export default Usage